import { render, staticRenderFns } from "./mvmStatusPanel.vue?vue&type=template&id=35a3f23c&scoped=true"
import script from "./mvmStatusPanel.vue?vue&type=script&lang=js"
export * from "./mvmStatusPanel.vue?vue&type=script&lang=js"
import style0 from "./mvmStatusPanel.vue?vue&type=style&index=0&id=35a3f23c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35a3f23c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/kasingkhoo/Projects/PECOS/pecos_ivm_apiserver-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('35a3f23c')) {
      api.createRecord('35a3f23c', component.options)
    } else {
      api.reload('35a3f23c', component.options)
    }
    module.hot.accept("./mvmStatusPanel.vue?vue&type=template&id=35a3f23c&scoped=true", function () {
      api.rerender('35a3f23c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dashboard/components/mvmStatusPanel.vue"
export default component.exports